import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '@/store'
import { SET_LANG, SET_LOGIN_USER } from '@/store/mutation-types'
Vue.use(VueRouter)

// 航空提单
const billOfLadingQuery = () => import('@/views/airway-bill/bill-of-lading-query.vue');

const routes = [
  {
    path: '/',
    redirect: '/en/login'
  },
  {
    path: '/:lang/login',
    name: 'login',
    component: () => import('../views/login'),
    meta: {
      authenticate: false,
      role: [],
    }
  },
  {
    path: '/:lang/home',
    name: 'home',
    component: Home,
    meta: {
      authenticate: false,
      role: ['A', 'B', 'C', 'D']
    }
  },
  {
    path: '/:lang/airway-bill-query',
    name: 'airway-bill-query',
    component: billOfLadingQuery,
    meta: {
      authenticate: false,
      role: []
    },
  },
  {
    path: '/:lang/airway-bill-query-detail/:houseNo',
    name: 'airway-bill-query-detail',
    component: () => import('../views/airway-bill/bill-of-lading-detail.vue'),
    meta: {
      authenticate: false,
      role: []
    },
  },
  {
    path: '/:lang/branch-bill-of-lading-query-list',
    name: 'branch-bill-of-lading-query-list',
    component: () => import('../views/airway-bill/branch-bill-of-lading-query-list.vue'),
    meta: {
      authenticate: false,
      role: []
    },
  },
  {
    path: '/:lang/branch-bill-of-lading-query-list-deatils',
    name: 'branch-bill-of-lading-query-list-deatils',
    component: () => import('../views/airway-bill/branch-bill-of-lading-query-list-deatils.vue'),
    meta: {
      authenticate: false,

      role: []
    },
  },
  {
    path: '/:lang/branch-bill-of-lading-query-Bldeatils',
    name: 'branch-bill-of-lading-query-Bldeatils',
    component: () => import('../views/airway-bill/branch-bill-of-lading-query-Bldeatils.vue'),
    meta: {
      authenticate: false,
      role: []
    },
  },
  {
    path: '/:lang/branch-bill-of-lading-query-Awbdeatils',
    name: 'branch-bill-of-lading-query-Awbdeatils',
    component: () => import('../views/airway-bill/branch-bill-of-lading-query-Awbdeatils.vue'),
    meta: {
      authenticate: false,
      role: []
    },
  },
  {
    path: '/:lang/branch-bill-of-lading-query',
    name: 'branch-bill-of-lading-query',
    component: () => import('../views/airway-bill/branch-bill-of-lading-query.vue'),
    meta: {
      authenticate: false,
      role: []
    },
  },

  {
    path: '/:lang/add-bl',
    name: 'add-bl',
    component: () => import('../views/awb-bl/addBL.vue'),
    meta: {
      authenticate: false,
      role: []
    }
  },
  {
    path: '/:lang/add-awb',
    name: 'add-awb',
    component: () => import('../views/awb-bl/addAwb.vue'),
    meta: {
      authenticate: false,
      role: []
    }
  },
  {
    path: '/:lang/user-manager/add',
    name: 'user-manager-add',
    component: () => import('../views/system/user-manager/user-edit.vue'),
    props: {
      operation: 'add'
    },
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-manager/edit/:userId',
    name: 'user-manager-edit',
    component: () => import('../views/system/user-manager/user-edit.vue'),
    props: {
      operation: 'edit'
    },
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-manager/list',
    name: 'user-manager-list',
    component: () => import('../views/system/user-manager/user-list.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-awb-query',
    name: 'user-awb-query',
    component: () => import('../views/userActions/user-awb-query.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-awb-query-list',
    name: 'user-awb-query-list',
    component: () => import('../views/userActions/user-awb-query-list.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-awb-query-no',
    name: 'user-awb-query-no',
    component: () => import('../views/userActions/user-awb-query-no.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-awb-query-poInv',
    name: 'user-awb-query-poInv',
    component: () => import('../views/userActions/user-awb-query-poInv.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-awb-query-state',
    name: 'user-awb-query-state',
    component: () => import('../views/userActions/user-awb-query-state.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-awb-query-container',
    name: 'user-awb-query-container',
    component: () => import('../views/userActions/user-awb-query-container.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-awb-query-Seafreightno',
    name: 'user-awb-query-Seafreightno',
    component: () => import('../views/userActions/user-awb-query-Seafreightno.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-actions/imex-report',
    name: 'user-actions-imex-report',
    component: () => import('../views/userActions/imex-report.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-actions/upload-invoice-purchase-order',
    name: 'upload-invoice-purchase-order',
    component: () => import('../views/userActions/upload-invoice-purchase-order.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-actions/Quarterly_Report',
    name: 'Quarterly_Report',
    component: () => import('../views/userActions/Quarterly_Report.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
  {
    path: '/:lang/user-actions/Monthly_report',
    name: 'Monthly_report',
    component: () => import('../views/userActions/Monthly_report.vue'),
    meta: {
      authenticate: true,
      role: []
    }
  },
 
  {
    path: "*",
    component: () => import('../views/login'),
    meta: {
      authenticate: false,
      role: [],
    }
  }
]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//路由拦截
router.beforeEach((to, from, next) => {
  //未登录则跳转到登录页面
  if (to.meta && to.meta.authenticate && store.getters.user === null) {
    next({ name: 'login' });
    return;
  }

  if (to.params.lang) {
    store.commit(SET_LANG, to.params.lang);
  } else {
    Vue.prototype.changeLanguage(store.getters.lang);
  }
  // console.log(to)
  // console.log(from)
  // if (to.name == "user-awb-query-list" && from.name == "user-awb-query") {
  //   to.meta.keepAlive = false;  // 让 列表页 即不缓存，刷新
  //  console.log("进来了不缓存页面");
  //   next();
  // }
  // if ((to.name == "user-awb-query-list"|| from.name == "user-awb-query-list" ) && from.name != "user-awb-query") {
  //   to.meta.keepAlive = true;  // 让 列表页 即不缓存，刷新
  //  console.log("进来了缓存页面");
  //   next();
  // }
  
  
  if( to.name == "airway-bill-query" && from.name == "login"){
   // to.meta.keepAlive = false; 
    next();
  }
  else {
    next();
  }

})

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
